import React from "react";
import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { SurveyProvider } from "./hooks/useSurvey";
import Landing from "./pages/Landing";
import Survey from "./pages/Survey";
import Glimpse from "./pages/Glimpse";
import Snapshot from "./pages/Snapshot";
import Returning from "./pages/Returning";
import Results from "./pages/Results";
import Status from "./pages/Status";
import Report from "./pages/Report";
import { AdminAuthProvider } from "./admin/AdminAuthContext";
import { AdminLayout } from "./admin/AdminLayout";
import AdminLogin from "./admin/pages/AdminLogin";
import AdminDashboard from "./admin/pages/AdminDashboard";
import AdminResponses from "./admin/pages/AdminResponses";
import AdminReferrers from "./admin/pages/AdminReferrers";
import AdminAnalysis from "./admin/pages/AdminAnalysis";

function App() {
    return (
        <div className="App">
            <AdminAuthProvider>
                <SurveyProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/" element={<Landing />} />
                            <Route path="/survey" element={<Survey />} />
                            <Route path="/glimpse" element={<Glimpse />} />
                            <Route path="/snapshot/:response_id" element={<Snapshot />} />
                            <Route path="/returning" element={<Returning />} />
                            <Route path="/results" element={<Results />} />
                            <Route path="/track" element={<Status />} />
                            <Route path="/r/:code" element={<Status />} />
                            <Route path="/report/:response_id" element={<Report />} />

                            {/* Admin */}
                            <Route path="/admin/login" element={<AdminLogin />} />
                            <Route path="/admin" element={<AdminLayout />}>
                                <Route index element={<Navigate to="/admin/dashboard" replace />} />
                                <Route path="dashboard" element={<AdminDashboard />} />
                                <Route path="responses" element={<AdminResponses />} />
                                <Route path="referrers" element={<AdminReferrers />} />
                                <Route path="analysis" element={<AdminAnalysis />} />
                            </Route>

                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </BrowserRouter>
                </SurveyProvider>
            </AdminAuthProvider>
        </div>
    );
}

export default App;
